import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios';
import { API_URL } from '../actions/constant';



const platformSlice = createSlice({
    name: 'crud',
    initialState: {
        setting: {},
    },
    reducers: {
        listsetting: (state, action) => {
            state.setting = action.payload
        },
    },
})

export const { listsetting } = platformSlice.actions

//API CALLS
export const getSetting = () => dispatch => {
    axios.get(`${API_URL}/api/setting`)
        .then(res => {
            dispatch(listsetting(res.data))

        })
        .catch(err => {
        });
};



export default platformSlice.reducer
